/* eslint-disable */
import React from 'react';
import {
    Datagrid,
    TextField,
    ReferenceField,
    ArrayField,
    ShowView,
    SimpleShowLayout,
    DateField,
    BooleanField,
    useShowController,
    ShowContextProvider,
    useRecordContext,
    Labeled,
} from 'react-admin';

import ModuleField, { ModuleReferenceField } from '../../lib/ModuleField';
import { DeliveryRenderer } from '../Course/Tabs/CourseDeliveriesTabs';
import { dateFormat } from '../../lib/Formats';

const CourseInstanceShow = (props) => {
    const controllerProps = useShowController();

    return (
        <ShowContextProvider value={controllerProps}>
            <ShowView {...props}>
                <SimpleShowLayout>
                    <ParentCourseShow />
                    <ReferenceField
                        label="myroot.parentCourseQualification"
                        reference="Course"
                        source="courseId"
                        link="show"
                    >
                        <ReferenceField
                            reference="QualificationType"
                            source="qualificationId"
                            link="show"
                        >
                            <TextField source="Title" />
                        </ReferenceField>
                    </ReferenceField>
                    <CourseDeliveryField {...props} />
                    <ReferenceField
                        reference="CampusLocation"
                        source="campusLocation"
                        link="show"
                    >
                        <TextField source="Title" />
                    </ReferenceField>
                    <ArrayField source="modules">
                        <Datagrid bulkActionButtons={false}>
                            <ReferenceField
                                reference="Module"
                                source="moduleId"
                                link="show"
                                label="myroot.moduleCode"
                            >
                                <TextField source="moduleCode" />
                            </ReferenceField>
                            <ReferenceField
                                reference="Module"
                                source="moduleId"
                                link="show"
                                label="myroot.module"
                            >
                                <TextField source="shortTitle" />
                            </ReferenceField>
                            <ReferenceField
                                reference="Module"
                                source="moduleId"
                                link="show"
                                label="myroot.CreditValue"
                            >
                                <ReferenceField
                                    reference="CreditValue"
                                    source="creditValueId"
                                    link="show"
                                >
                                    <TextField source="creditvalue" />
                                </ReferenceField>
                            </ReferenceField>
                            <ReferenceField
                                reference="Module"
                                source="moduleId"
                                link="show"
                                label="myroot.status"
                            >
                                <ReferenceField
                                    reference="Status"
                                    source="statusId"
                                    link="show"
                                >
                                    <TextField source="Title" />
                                </ReferenceField>
                            </ReferenceField>
                        </Datagrid>
                    </ArrayField>
                    {/* <ArrayField source="variations">
                        <Datagrid bulkActionButtons={false}>
                            <ReferenceField
                                reference="Module"
                                source="id"
                                link="show"
                                label="myroot.moduleCode"
                            >
                                <TextField source="moduleCode" />
                            </ReferenceField>
                            <ReferenceField
                                reference="Module"
                                source="id"
                                link="show"
                                label="myroot.module"
                            >
                                <TextField source="shortTitle" />
                            </ReferenceField>
                            <ReferenceField
                                reference="Module"
                                source="id"
                                link="show"
                                label="myroot.CreditValue"
                            >
                                <ReferenceField
                                    reference="CreditValue"
                                    source="creditValueId"
                                    link="show"
                                >
                                    <TextField source="creditvalue" />
                                </ReferenceField>
                            </ReferenceField>
                            <ReferenceField
                                reference="Module"
                                source="id"
                                link="show"
                                label="myroot.status"
                            >
                                <ReferenceField
                                    reference="Status"
                                    source="statusId"
                                    link="show"
                                >
                                    <TextField source="Title" />
                                </ReferenceField>
                            </ReferenceField>
                        </Datagrid>
                    </ArrayField>  TODO: remove from API using migrations */}
                    <ArrayField source="yearsAndDates">
                        <Datagrid bulkActionButtons={false}>
                            <TextField
                                source="courseYear"
                                label="myroot.yearOfStudy"
                            />
                            <DateField
                                source="startDate"
                                options={dateFormat}
                                label="myroot.startDate"
                            />
                            <DateField
                                source="endDate"
                                options={dateFormat}
                                label="myroot.endDate"
                            />
                            <TextField
                                source="academicSession"
                                label="myroot.academicSession"
                            />
                        </Datagrid>
                    </ArrayField>
                    <ReferenceField
                        reference="Status"
                        source="statusId"
                        link="show"
                    >
                        <TextField source="Title" />
                    </ReferenceField>
                    {controllerProps.record ? (
                        <BooleanField
                            source="franchise"
                            label="myroot.franchise"
                        />
                    ) : null}
                </SimpleShowLayout>
            </ShowView>
        </ShowContextProvider>
    );
};

export default CourseInstanceShow;

const ParentCourseShow = () => {
    const { isAssociateCourse } = useRecordContext();
    const courseReference = isAssociateCourse ? 'AssociateCourse' : 'Course';

    const courseSource = isAssociateCourse
        ? 'associateCourseCode'
        : 'courseId';


    return (
        <>
            <div>
                <Labeled>
                    <ReferenceField
                        label="myroot.parentCourseCode"
                        reference={courseReference}
                        source="courseCode"
                        link="show"
                    >
                        <TextField source="id" />
                    </ReferenceField>
                </Labeled>
            </div>
            <div>
                <Labeled>
                    <ReferenceField
                        label="myroot.parentCourseTitle"
                        reference={courseReference}
                        source="courseCode"
                        link="show"
                    >
                        <TextField source="Title" />
                    </ReferenceField>
                </Labeled>
            </div>
        </>
    );
};

export const CourseDeliveryField = (props) => {
    const record = useRecordContext();
    if (record.courseDelivery) {
        let deliveryObj = null;
        try {
            deliveryObj = JSON.parse(
                record.courseDelivery.replace(/\\"/g, '"').replace(/'/g, '"')
            );
        } catch (error) {
            console.log('Error parsing deliveryObj : ', record.courseDelivery);
        }

        //  I'm not proud of this.
        // It creates a props object with a suitable record for the course deliveries
        // and the minimum of other information.
        // props.record is read only.
        var myprops = {
            basePath: props.basePath,
            history: props.history,
            record: deliveryObj,
        };
        return <DeliveryRenderer {...myprops} />;
    } else return null;
};

const InstanceModuleField = (props) =>
    props.instance ? (
        props.instance.unusedModuleIds ? (
            <ModuleField
                {...props}
                replacedIds={props.instance.unusedModuleIds}
                source={props.fieldInQuestion}
            />
        ) : (
            <ModuleField
                {...props}
                replacedIds={null}
                source={props.fieldInQuestion}
            />
        )
    ) : null;

const InstanceModuleReferenceField = (props) =>
    props.instance ? (
        props.instance.unusedModuleIds ? (
            <ModuleReferenceField
                {...props}
                replacedIds={props.instance.unusedModuleIds}
                reference={props.reference}
                source={props.source}
                referencedSource={props.referencedSource}
            />
        ) : (
            <ModuleReferenceField
                {...props}
                replacedIds={null}
                reference={props.reference}
                source={props.source}
                referencedSource={props.referencedSource}
            />
        )
    ) : null;
